import { render } from "./TableProjects.vue?vue&type=template&id=047ee334&scoped=true"
import script from "./tableprojects.view.js?vue&type=script&lang=js&external"
export * from "./tableprojects.view.js?vue&type=script&lang=js&external"

import "./tableprojects.css?vue&type=style&index=0&id=047ee334&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047ee334"]])

export default __exports__